import type { ReactNode } from 'react';

import { atom, type PrimitiveAtom } from 'jotai';

/**
 * Atom that allows pages to inject custom action buttons into the NavigationBar.
 *
 * Pages set this on mount via `useSetAtom(NavActionsAtom)` and clear it (set to `null`)
 * on unmount. The NavigationBar reads it via `useAtomValue(NavActionsAtom)` and renders
 * the actions in `TopNavEnd` before the AccountMenu.
 */
export const NavActionsAtom: PrimitiveAtom<ReactNode> & {
	init: ReactNode;
} = atom<ReactNode | null>(null);
